import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-194d3c23"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex align-items-center" }
const _hoisted_2 = { class: "font-bold" }
const _hoisted_3 = { class: "justify-content-end text-right" }
const _hoisted_4 = { class: "email-meta formgrid grid mb-2" }
const _hoisted_5 = { class: "col-12" }
const _hoisted_6 = { class: "formgrid grid" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "col-2 text-500" }, "Od:", -1))
const _hoisted_8 = { class: "col-10" }
const _hoisted_9 = {
  key: 0,
  class: "ml-1"
}
const _hoisted_10 = {
  key: 0,
  class: "formgrid mt-0 grid"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "col-2 text-500" }, "Pre:", -1))
const _hoisted_12 = { class: "col-10" }
const _hoisted_13 = { class: "ml-1" }
const _hoisted_14 = {
  key: 0,
  class: "email-body scrollable-body"
}
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = {
  key: 1,
  class: "email-body"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AttachmentList = _resolveComponent("AttachmentList")!
  const _component_PrimevuePanel = _resolveComponent("PrimevuePanel")!

  return (_openBlock(), _createBlock(_component_PrimevuePanel, { class: "border-solid border-1 surface-border" }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", _hoisted_2, _toDisplayString(this.$props.internal ? '' : (this.$props.message.subject || 'Bez predmetu')), 1)
      ])
    ]),
    icons: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("em", null, _toDisplayString($options.Utils.parseToSlovakDateTime(this.$props.message.createdAt) || 'Neznámy dátum'), 1)
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("strong", null, _toDisplayString(this.$props.message.fromName || 'Neznámy odosielateľ'), 1),
              (!this.$props.internal)
                ? (_openBlock(), _createElementBlock("span", _hoisted_9, "<" + _toDisplayString(this.$props.message.fromEmail  || 'Bez emailu') + ">", 1))
                : _createCommentVNode("", true)
            ])
          ]),
          (!this.$props.internal)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _hoisted_11,
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("span", null, _toDisplayString(this.$props.message.toName  || ''), 1),
                  _createElementVNode("span", _hoisted_13, _toDisplayString(this.$props.message.toEmail  || 'Bez emailu'), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      (!this.$props.internal)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _createElementVNode("div", { innerHTML: $data.formattedHtml }, null, 8, _hoisted_15)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(this.$props.message.bodyTxt), 1)),
      _createVNode(_component_AttachmentList, {
        messageId: String(this.$props.message.id),
        internal: this.$props.internal,
        attTypeId: 0
      }, null, 8, ["messageId", "internal"])
    ]),
    _: 1
  }))
}